import React from "react";

const EventDetailRow = ({ label, value, className ="" }) => {
  return (
    <div className="row">
      <div className="col-auto col-md-4 col-lg-3 col-xl-2 pr-0">
        {label && <span className="p-0 event-detail-heading">{label}</span>}
      </div>
      <div className={`col-auto col-md-8 col-lg-9 col-xl-10 ${className}`}>
        {value && <span className="p-0 event-detail-info">{value}</span>}
      </div>
    </div>
  );
};

export default EventDetailRow;
